const feedback = {
  thumbsLabel: "Is this helpful?",
  ticketSubmissionLabel: "Need additional assistance?",
  ticketSubmissionButtonText: "Submit a ticket",
};

const copy = {
  feedback,
  hcaFeedbackButton: "Provide Help Center Assistant feedback",
  linkGroup: {
    viewMore: "View more article sources",
    viewLess: "View less article sources",
  },
  retryCreateChat: "Failed to create chat. Please retry.",
  retryCreateChatLinkText: "Retry",
  regenerateSendMessage: "Message response failed.",
  regenerateSendMessageLinkText: "Regenerate",
  supportCta: {
    chat: {
      message: "Chat with a live agent",
      ctaText: "Need help?",
    },
  },
};

export default copy;
